$(document).ready(function() {
	$('.news-section__top-list .nav-item').removeClass('active');
	$('.news-section__top-list .nav-item button').removeClass('active');

	if ($('.news-section__top-list .nav-item').length) {
			var $firstTab = $('.news-section__top-list .nav-item').first();
			var $firstButton = $firstTab.find('button');

			$firstTab.addClass('active');
			$firstButton.addClass('active');

			var firstTabId = $firstTab.attr('id');
			var targetTab = $firstTab.data('bs-target');

			var $tabElement = $('#' + firstTabId);
			if ($tabElement.length) {
					var tab = new bootstrap.Tab($tabElement.get(0)); 
					tab.show();
			}
	}
});



$(document).ready(function () {


	 $('.modal').on('hidden.bs.modal', function () {
    $(this).find('iframe').attr('src', function (i, val) {
      return val;  
    });
  });


	$('.customers-section__slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 2000,
		cssEase: 'linear',
		arrows: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					margin: 5,
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});
	


   // Обработка клика по вкладкам
	 $('.overview-section__tab').on('click', function () {
		var tabId = $(this).data('tab');

		$('.overview-section__tab').removeClass('active');
		$('.overview-section__tab-content').css({
				'max-height': '0',
				'opacity': '0',
				'visibility': 'hidden'
		});
		$('.overview-section__image').removeClass('active').hide();
		$('.overview-section__video').removeClass('active').hide(); // Скрытие видео
		$('.overview-section__mobile-text').hide();

		$(this).addClass('active');
		var $activeText = $(this).find('.overview-section__tab-content');
		$activeText.css({
				'max-height': $activeText.prop('scrollHeight') + 'px',
				'opacity': '1',
				'visibility': 'visible'
		});

		var $activeImage = $('.overview-section__image[data-tab="' + tabId + '"]');
		$activeImage.show().addClass('active');

		var $activeVideo = $('.overview-section__video[data-tab="' + tabId + '"]');
		$activeVideo.show().addClass('active');

		if ($(window).width() <= 991) {
				$('.overview-section__mobile-text').hide(); 
				$('.overview-section__mobile-text[data-tab="' + tabId + '"]').show();
		}
});

// Обработка изменения значения в выпадающем списке
$('#overview-dropdown').on('change', function () {
		var tabId = $(this).val();

		$('.overview-section__image').removeClass('active').hide();
		var $activeImage = $('.overview-section__image[data-tab="' + tabId + '"]');
		$activeImage.show().addClass('active');

		$('.overview-section__video').removeClass('active').hide(); // Скрытие видео
		var $activeVideo = $('.overview-section__video[data-tab="' + tabId + '"]');
		$activeVideo.show().addClass('active');

		$('.overview-section__mobile-text').removeClass('active');

		$('.overview-section__mobile-text[data-tab="' + tabId + '"]').addClass('active');
});

// Инициализация отображения текста для мобильных устройств при загрузке
if ($(window).width() <= 991) {
		var initialTabId = $('#overview-dropdown').val();
		$('.overview-section__mobile-text').removeClass('active'); 
		$('.overview-section__mobile-text[data-tab="' + initialTabId + '"]').addClass('active');
}



	$('.menu-burger').on('click', function (event) {
		event.preventDefault();

		$('.col-mobile-position').toggleClass('menu-open');

		$('body').toggleClass('no-scroll');

		$(this).toggleClass('open');

	});




	$('#impactSelect').on('change', function () {
		var target = $(this).val();

		$('.impact-section__content-pane').removeClass('show active');

		$(target).addClass('show active');
	});

	var initialValue = $('#impactSelect').val();
	$(initialValue).addClass('show active');




		var owl = $(".owl-carousel").owlCarousel({
			items: 3.5,
			margin: 30,
			loop: true,
			nav: false,
			dots: false,
			autoplay: false,
			responsive: {
				0: {
					items: 1.2,
				},
				350: {
					items: 1.5,
				},
				570: {
					items: 2.5,
				},
				992: {
					items: 3.5,
				},
			}
		});

		$(".prev_button").click(function () {
			owl.trigger("prev.owl.carousel");
		});

		$(".next_button").click(function () {
			owl.trigger("next.owl.carousel");
		});




	let i = 0;

	$('.article-single__items h3').each(function () {
		i++; 
		const itemID = 'titleID-' + i; 
		$(this).attr('id', itemID); 
		const title = $(this).text(); 

		let titleCropped;
		if ($(window).width() <= 992) {
			titleCropped = title.substring(0, 20) + '...'; 
		} else {
			titleCropped = title.substring(0, 18) + '...'; 
		}

		$('.article-single__nav-wrap .article-single__nav').append('<li><a href="#' + itemID + '">' + titleCropped + '</a></li>');
	});




	$('.article-single__nav').on('click', 'a', function (e) {
		e.preventDefault();


		$('.article-single__nav a').removeClass('active').css({
			'font-size': '14px',
			'color':'#000'

		});


		$(this).addClass('active').css({
			'color':'#406449'
		}); 

	 
		const target = $(this).attr('href');
		let offset = $(window).width() <= 992 ? 70 : 200;
		if (target) {
			$('html, body').animate({
				scrollTop: $(target).offset().top - offset
			}, 400);
		} 
	});  

 
	$('.news-section__top-item').on('click', function () {
		$('.news-section__top-item').removeClass('active');
		$(this).addClass('active');
	});
 

	$('#all-tab').on('click', function (event) {
		event.preventDefault();
		var tabTrigger = new bootstrap.Tab(this);
		tabTrigger.show();
	});


	$(window).on('resize', function () {
		$('.news-section__slider').slick('setPosition');
	});



	$('#all-tab').on('shown.bs.tab', function (e) {
		if ($(e.target).attr('id') === '#tabs') { 
			$('.news-section__slider').slick('setPosition');
		}
	});




	var activeTabIndex = 0;
	var tabs = $('.hiring-section__tab');
	var intervalDuration = 10000; 
	var progressBarClass = 'progress-bar';
	var timer; 
	var isProgressStarted = false;

	function createProgressBar($tab) {
		if ($tab.find('.' + progressBarClass).length === 0) {
			$('<div class="' + progressBarClass + '"></div>').appendTo($tab);
		}
	}

	function startProgressBar($progressBar) {
		$progressBar.css({ 'width': '0', 'transition': 'none' }); 
		setTimeout(function () { 
			$progressBar.css({ 'transition': 'width ' + (intervalDuration - 100) + 'ms linear', 'width': '100%' });
		}, 10);
		timer = setTimeout(nextTab, intervalDuration); 
	}

	function resetProgressBars() {
		$('.progress-bar').css({ 'transition': 'none', 'width': '0' }); 
		clearTimeout(timer);
	}

	function nextTab() {
		activeTabIndex = (activeTabIndex + 1) % tabs.length;
		var $nextTab = $(tabs[activeTabIndex]);
		$nextTab.trigger('click');
	}

	tabs.on('click', function () {
		var $tab = $(this);

		if ($tab.hasClass('active')) {
			return; 
		}

		resetProgressBars(); 

	
		activeTabIndex = tabs.index($tab);

		var tabId = $tab.data('tab');
		var $content = $tab.find('.hiring-section__tab-content');
		var $image = $('.hiring-section__image[data-tab="' + tabId + '"]');
		var $progressBar = $tab.find('.progress-bar');


		$('.hiring-section__tab').removeClass('active')
			.find('.hiring-section__tab-content').hide().css('opacity', 0);
		$('.hiring-section__image').removeClass('active').css('opacity', 0).hide();


		$tab.addClass('active');
		$content.show().css('opacity', 1);
		$image.addClass('active').css('opacity', 1).fadeIn(400);

		startProgressBar($progressBar); 
	});


	function initializeTabs() {
		var $activeTab = tabs.eq(activeTabIndex).addClass('active');
		var activeTabId = $activeTab.data('tab');
		$activeTab.find('.hiring-section__tab-content').show().css('opacity', 1);
		$('.hiring-section__image[data-tab="' + activeTabId + '"]').addClass('active').css('opacity', 1).show();
		createProgressBar($activeTab);
		startProgressBar($activeTab.find('.progress-bar')); 
	}

  var isProgressStarted = false; 


    var $observerTarget = $('.hiring-section');

   
    if ($observerTarget.length === 0) {
        console.warn('Element with class ".hiring-section" not found.');
        return; 
    }

    $(window).on('scroll', function () {
        if (!isProgressStarted) {

            if ($observerTarget.length) {
                var targetTop = $observerTarget.offset().top;
                var windowHeight = $(window).height();
                var scrollPosition = $(this).scrollTop();

               
                if (typeof targetTop === 'number' && typeof $observerTarget.height() === 'number') {
                   
                    if (scrollPosition + windowHeight >= targetTop + $observerTarget.height() * 0.5) {
                        isProgressStarted = true;
                        initializeTabs();
                    }
                } else {
                    console.error('Invalid values for targetTop or element height.');
                }
            } else {
                console.warn('$observerTarget is not available.');
            }
        }
    });





			let $slider = $('.customers-section__slider');
	
			function initSlider() {
					$slider.slick({
							slidesToShow: 3,
							slidesToScroll: 1, 
							dots: true,
							arrows: true,
					});
			}
	
			initSlider(); 
	
			$('.nav-item').on('shown.bs.tab', function(e) {
					if ($(e.target).find('.customers-section__slider').length > 0) {
							$slider.slick('unslick');
							initSlider();
					}
			}); 



			$(window).on('load', function() {
				$('.news-section__top ul li').removeClass('active');
				$('.news-section__top ul li').first().addClass('active');
		});

	
});




